module.exports = __webpack_public_path__ + "media/4_Long.90c8c9b5.mp3";